<template>
  <section :class="{
		'container-Moblie': isMobile,
		'container-PC': !isMobile
	}">
    <article class="page">
      <tuwen @closeTuwen="closeTuwen($event)"
             @saveChatlist="tuwenfeedback($event)"
             :graphicData="graphicData"
             ref="tuwen" />

      <cateBox ref="cateBox"
               :cityname="cityname"
               @selectCate_two="selectCate2($event)"></cateBox>

      <section v-show="showCate()">
        <div class="cateButton flex"
             v-show="cateList.length > 0"
             @click="$refs.cateBox.boxSwitch(true)">
          <span v-if="currentCate"
                class="cateButton-txt">{{currentCate}}</span>
          <img v-else
               class="cateButton-icon"
               src="@/assets/robot/cateReply/list.png"
               alt="">
        </div>
      </section>

      <section class="main"
               ref="main">
        <!-- <div @click="simplifyChatList">点击简化</div> -->

        <!-- 点击答案中的图片时，显示大图 -->
        <div class="image-look-mark"
             @click="hideImage"
             v-if="nowSeeImage">
          <div class="image-box">
            <img :src="nowSeeImage"
                 alt="图片加载失败">
          </div>
        </div>
        <!-- 点击答案中的图片时，显示大图 -->

        <section class="chat"
                 ref="content">

          <section class="chat-item flex between"
                   v-for="(item,chatIndex) in chatList"
                   :key="chatIndex">

            <section v-if="item.target == 'time'"
                     class="chat_time flex center">
              <div>{{item.time }}</div>
            </section>

            <section v-if="item.target=='topOver'"
                     class="top-box flex center">
              <div class="top-over">{{topOverTips}}</div>
            </section>

            <!-- 分类 -->
            <section v-if="item.target=='cate'"
                     class="chat_time flex center">
              <article class="QCate"
                       v-show="cateList.length > 1">
                <header class="QCate-H flex between">
                  <div class="QCate-H-l">选择您要咨询的业务</div>
                  <div class="QCate-H-r"
                       @click="$refs.cateBox.boxSwitch(true)">全部业务 ></div>
                </header>
                <footer class="QCate-F flex between">
                  <div class="QCate-F-item flex col"
                       v-if="cate1.name !== '其他'"
                       v-for="(cate1,cate1_index) in cateList.slice(0,6)"
                       :key="cate1_index"
                       @click="changeCate(cate1_index)">
                    <img class="QCate-F-item-icon"
                         :src="iconList[cate1.name]"
                         alt="">
                    <span class="QCate-F-item-txt">{{cate1.name}}</span>
                  </div>
                </footer>
              </article>
            </section>
            <!-- 分类 -->

            <section v-if="item.target === 'r'"
                     class="flex align-start">

              <!-- 初始对话 + 猜你想问 -->
              <article v-if="item.type === 'init'">
                <div class="init-robot-say">
                  <div>
                    <img src="../assets/robot/newimage/robot_profile.png"
                         alt="">
                  </div>
                  <div class="content"
                       v-html="item.initWord"></div>
                </div>

                <div v-if="item.guess.length"
                     class="guess all-border">
                  <div class="guess-H flex between">
                    <div class="flex">
                      <img class="guess-Q"
                           src="../assets/robot/guess-Q.png" />
                      <img class="guess-icon"
                           src="../assets/robot/newimage/icon-gusse.png" />
                    </div>
                    <div @click="guessChange(chatIndex)"
                         v-if="item.guess.length > 6">
                      <img class="guess-refre"
                           src="../assets/robot/guess-refre.png"
                           mode="" />
                      <span class="guess-change">换一换</span>
                    </div>
                  </div>

                  <div class="guess-C"
                       :class="{'guess-C-height': item.guess.length > 6} ">
                    <div class="guess-C-i flex between"
                         @click="query(guess_i.title, {...guess_i})"
                         v-if="guess_index >= item.minIndex && guess_index <= item.minIndex + 5"
                         v-for="(guess_i,guess_index) in item.guess"
                         :key="guess_index">
                      <div v-show="!guess_i.content"
                           class="guess-C-i-text">{{guess_i.title}}</div>
                      <div v-show="guess_i.content"
                           style="color: #ffa023"
                           class="guess-C-i-text">{{guess_i.title}}相关问题</div>
                      <img class="guess-goto"
                           src="../assets/robot/guess-goto.png"
                           mode="" />
                    </div>
                  </div>
                </div>
              </article>
              <!-- 初始对话 + 猜你想问 -->

              <!--  你可能想知道 -->
              <article v-if="item.type == 'relevantQ'"
                       class="relevantQ all-border">
                <header class="relevantQ-H flex between">
                  <span class="relevantQ-H-txt1">您可能想知道：</span>
                  <div class="flex"
                       @click="releChange(chatIndex)"
                       v-if="item.pro_list.length > 5">
                    <img class="relevantQ-H-refre"
                         src="../assets/robot/guess-refre.png"
                         mode=""></img>
                    <span class="relevantQ-H-txt2">换一批</span>
                  </div>
                </header>
                <main class="relevantQ-C"
                      :class="{'relevantQ-C-height': item.pro_list.length > 5 }">
                  <div class="relevantQ-C-i flex"
                       v-if="proIndex >= item.minIndex && proIndex <= item.minIndex + 4"
                       v-for="(pro,proIndex) in item.pro_list"
                       :key="proIndex"
                       @click="query(pro.title,pro,item)">
                    <div class="relevantQ-C-i-h"></div>
                    <div class="relevantQ-C-i-c">
                      <span v-if="pro.type">(文章)</span>
                      <span>{{pro.title}}</span>
                    </div>
                  </div>
                </main>
              </article>
              <!-- 你可能想知道 -->

              <!--  常见问题 -->
              <article v-if="item.type == 'cateCommon'">
                <div class="cateCommon-tips flex center">已接入{{item.cateType}}机器人</div>
                <article class="cateCommon"
                         v-if="item.pro_list.length">
                  <header class="cateCommon-H flex between">
                    <section class="flex">
                      <img class="cateCommon-H-l-icon1"
                           src="@/assets/robot/commonQ/cateCommon-H-l-icon1.png"
                           alt="">
                      <img class="cateCommon-H-l-icon2"
                           src="@/assets/robot/commonQ/cateCommon-H-l-icon2.png"
                           alt="">
                    </section>

                    <section v-if="item.pro_list.length > 6"
                             class="flex"
                             @click="changeCateQ(chatIndex)">
                      <img class="cateCommon-H-r-icon1"
                           src="@/assets/robot/commonQ/cateCommon-H-r-icon1.png"
                           alt="">
                      <div class="cateCommon-H-r-txt">换一换</div>
                    </section>
                  </header>

                  <footer class="cateCommon-F"
                          :class="{'cateCommon-F-height': item.pro_list.length > 6}">
                    <section class="cateCommon-F-item flex between"
                             v-for="(Q,QIndex) in item.pro_list.slice(item.minIndex,item.minIndex + 6)"
                             :key="QIndex"
                             @click="query(Q.title)">
                      <span class="cateCommon-F-item-txt">{{Q.title}}</span>
                      <img class="cateCommon-F-item-icon"
                           src="@/assets/robot/commonQ/arrow-right.png"
                           alt="">
                    </section>
                  </footer>
                </article>
              </article>
              <!--  常见问题 -->

              <!-- 标准出行政策：符合关键词提取的情况，给出迷你版的出行政策板块 -->
              <div v-if="item.type == 'standardgoout'"
                   class="standard-goout-box">
                <div class="from-outer-box">
                  <div class="from-place-title">
                    <div class="place-title-left">
                      <img src="@/assets/robot/newimage/icon-from.png" />
                      <span>出{{ item.geli_data.leavecity[0].leavecity }}</span>
                    </div>
                    <div class="place-title-right">
                      <img @click="handleCallPhone({
														code: item.geli_data.chufa_citycode,
														type: 'from'})"
                           src="@/assets/robot/newimage/icon-phone.png" />
                    </div>
                  </div>
                  <div class="from-place-detail">
                    <div class="from-detai-info">
                      <div class="detail-info">
                        <div class="yaodian"
                             v-for="( yaodian, index) in item.geli_data.chu_leave.yaodian"
                             :key="index">
                          {{index+1}}.&nbsp;{{yaodian}}
                        </div>
                        <div>
                          {{ item.geli_data.chu_leave.daoyu }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="to-outer-box">
                  <div class="to-place-title">
                    <div class="place-title-left">
                      <img src="@/assets/robot/newimage/icon-to.png" />
                      <span>进{{ item.geli_data.leavecity[0].cityname }}</span>
                    </div>
                    <div class="place-title-right">
                      <img @click="handleCallPhone({
														goCityCode: item.geli_data.arrive_citycode,
														fromCityCode: item.geli_data.chufa_citycode,
														type: 'go'})"
                           src="@/assets/robot/newimage/icon-phone.png" />
                    </div>
                  </div>
                  <div class="to-place-detail">
                    <div class="to-detai-info">
                      <div class="detail-info"
                           v-if="item.arriveInfo !== ''"
                           style="padding: 0 24rpx">
                        <div @click="getDetailToPlace(detail_item, item)"
                             class="detail-item"
                             v-for="(detail_item, index) in item.arriveInfo"
                             :key="index">
                          <span>{{ detail_item.title }}</span>
                          <img src="@/assets/robot/guess-goto.png" />
                        </div>
                      </div>
                      <div class="detail-info"
                           v-if="item.arriveInfo !== '' && item.arriveInfo.length==0">
                        <div class="no-data">
                          暂无疫情政策
                        </div>
                      </div>
                      <div class="detail-info special"
                           v-if="item.specialPlace !== ''">
                        <div class="item-text"
                             v-for="(specialItem, index) in item.specialPlace.remark"
                             v-if="specialItem != ''"
                             :key="index">
                          {{ index + 1 }}.&nbsp;&nbsp;{{ specialItem }}
                        </div>
                        <div v-if="item.specialPlace.zhengce">
                          <div class="text"
                               v-html="$options.filters.hrefStyl(item.specialPlace.zhengce)">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="goto-more">
                  <span @click="
										  gotoChuXingZhengCe({
											fromCity: item.geli_data.leavecity[0].leavecity,
											fromCityCode: item.geli_data.chufa_citycode,											
											goCityCode: item.geli_data.arrive_citycode,
											goCityName: item.geli_data.leavecity[0].cityname,
											goQu: '全部',
											fromQu: '全部'
										  })">
                    查看详情&nbsp;&nbsp;>
                  </span>
                </div>
              </div>
              <!-- 标准出行政策 -->

              <!-- 标准问题卡片显示之后，下面的两个提示气泡 -->
              <div v-if="item.type == 'standartip1'"
                   class="commom-tip-bubble">
                <div>如果您不知晓所在地风险等级，可以点击
                  <span @click="gotoYiQingDengJi(item)">疫情等级</span>
                  进入查看
                </div>
              </div>

              <div v-if="item.type == 'standartip2'"
                   class="commom-tip-bubble">
                <div>想看其他城市出行政策，可参考回复以下格式：从深圳到武汉的出行政策</div>
              </div>

              <div v-if="item.type == 'standartip3'"
                   class="commom-tip-bubble">
                <div>
                  更多政策查看详情可点击
                  <span @click="getOtherCard(item.info, 1)">
                    &nbsp;出行政策 &nbsp;
                  </span>
                </div>
              </div>

              <!-- 从低/高风险地区进入某地 -->
              <div v-if="item.type == 'onetosomplace'"
                   class="one-to-someplace">
                <div class="title">
                  <div class="title-decretion"> </div>
                  <div class="title-true">
                    <span>{{ item.title }}</span>
                  </div>
                  <span @click="gotoChuXingZhengCe({
												fromCity: item.getMorePoro.leavecity[0].leavecity,
												fromCityCode: item.getMorePoro.chufa_citycode,											
												goCityCode: item.getMorePoro.arrive_citycode,
												goCityName: item.getMorePoro.leavecity[0].cityname,
												goQu: '全部',
												fromQu: '全部'
											  })">
                    查看详情&nbsp;>
                  </span>
                </div>
                <div class="content"
                     :class="item.flagShowAll?'':'show-all'">
                  <div class="item-text"
                       v-for="(orderItem, index) in item.yaodian"
                       v-if="orderItem != ''"
                       :key="index">
                    {{ index + 1 }}.&nbsp;&nbsp;{{ orderItem }}
                  </div>
                  <div v-if="item.content">
                    <div v-html="$options.filters.hrefStyl(item.content)"></div>
                  </div>
                  <div class="show-all"
                       v-if="item.flagShowAll">
                    <span @click="clickShowAll(item)">… 点击展开</span>
                  </div>
                </div>
              </div>
              <!-- 从低/高风险地区进入某地 -->

              <!--特殊出行政策—————— 输入的地名中有高风险地区的时候 -->
              <div v-if="item.type == 'special'"
                   class="special-place-box">
                <div class="title">
                  <img src="@/assets/robot/newimage/icon-question.png" />
                  <!-- <text>请选择您的具体出发地址</text> -->
                  <img src="@/assets/robot/newimage/icon-qxz.png" />
                </div>
                <div class="place-list">
                  <div class="place-item"
                       v-if="place.addr || place.area"
                       v-for="(place, index) in item.specialPlaceArr">
                    <div class="place"
                         @click="clickSpecialPlace({
											  place: place,
											  detailInfo: item.geli_data})">
                      {{ place.area+ " "+ place.addr }}
                    </div>
                    <img src="@/assets/robot/guess-goto.png" />
                  </div>
                  <div class="place-item">
                    <div class="place"
                         @click="clickSpecialPlace({
											  place: '以上都不是',
											  detailInfo: item.geli_data})">
                      以上都不是
                    </div>
                    <img src="@/assets/robot/guess-goto.png" />
                  </div>
                </div>
              </div>
              <!--特殊出行政策—————— 输入的地名中有高风险地区的时候 -->

              <!-- 和出行相关，但是没有预设问题时 -->
              <div v-if="item.type == 'unfound'"
                   class="no-place-goout">
                <div class="noplace-tips"
                     style="margin-bottom: 0">
                  <div class="noresult-reply"
                       v-html="$options.filters.hrefStyl(item.answer)">
                  </div>
                </div>

                <!-- <div class="outbox-four-btn">
                  <div class="title">
                    <img src="@/assets/robot/newimage/icon-question.png" />
                    <img src="@/assets/robot/newimage/icon-gusse.png" />
                  </div>
                  <div class="hot-choose">
                    <div class="double-choose">
                      <div class="item-box-left">
                        <div class="button-project"
                             @click="clickGoOutButton">
                          出行政策
                        </div>
                      </div>
                      <div class="item-box-right">
                        <div class="button-project"
                             @click="clickYQDJ('疫情等级')">
                          疫情等级
                        </div>
                      </div>
                    </div>
                    <div class="double-choose">
                      <div class="item-box-left">
                        <div class="button-project"
                             @click="userSend('核酸检测')">
                          核酸检测
                        </div>
                      </div>
                      <div class="item-box-right">
                        <div class="button-project"
                             @click="userSend('新冠疫苗')">
                          新冠疫苗
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
 -->

              </div>
              <!-- 和出行相关，但是没有预设问题 -->

              <!-- 提示输入始发地和目的地 div-->
              <div class="tipinputplace-box"
                   v-if="item.type == 'tipinputplace'">
                <div class="tip-input-place">
                  <div class="title">
                    <img src="@/assets/robot/newimage/icon-question.png" />
                    <img src="@/assets/robot/newimage/icon-qfs.png" />
                  </div>
                  <div class="tips"> 例：深圳到武汉（精确到市级） </div>
                </div>
                <div class="xiaobao-tip">
                  小宝温馨提醒：问题更准确，结果更精确哦~
                </div>
              </div>
              <!-- 提示输入始发地和目的地 -->

              <!-- 文章类型 -->
              <article v-if="item.type == 'article'"
                       class="article ">
                <div class="article-content all-border"
                     @click="openArticle(item.articleInfo.murl)">
                  <div class="article-H">
                    <div class="article-H-title">
                      {{item.articleInfo.title}}
                    </div>
                    <div class="article-H-note">{{item.articleInfo.guide}}</div>
                  </div>
                  <div class="article-F flex between">
                    <div class="flex">
                      <img class="article-F-icon"
                           src="../assets/robot/article-logo.png"
                           mode=""></img>
                      <span class="article-F-address">{{cityname}}本地宝</span>
                    </div>
                    <div>
                      <span class="article-F-time">{{item.articleInfo.publictime}}</span>
                    </div>
                  </div>
                </div>

                <div class="attitude"
                     v-if="!(chatIndex < fisrtTimeIndex&&item.attitude == '无')">
                  <div v-if="item.attitude === '无'">
                    <img @click="attitudeUp(chatIndex , '' , item.articleInfo.title)"
                         class="attitude-icon"
                         src="../assets/robot/feedback-up.png"
                         mode=""></img>
                    <img @click="attitudeDown(chatIndex , '' ,item.articleInfo.title)"
                         class="attitude-icon"
                         src="../assets/robot/feedback-down.png"
                         mode=""></img>
                  </div>
                  <div v-else>
                    <img v-if="item.attitude === '满意'"
                         class="attitude-icon"
                         src="../assets/robot/feedback-up-active.png"
                         mode=""></img>
                    <img v-else
                         class="attitude-icon"
                         src="../assets/robot/feedback-down-active.png"
                         mode=""></img>
                  </div>
                </div>
              </article>
              <!-- 文章类型 -->

              <!-- 问题答案 + 常见问题 -->
              <article v-if="item.type === 'answer'">
                <div v-if="item.cateType"
                     class="answer-tips flex center">已接入{{item.cateType}}客服</div>
                <!-- 问题答案 -->
                <section class="answer">
                  <article class="main-content all-border">
                    <div class="title flex">
                      <div><img src="../assets/robot/newimage/Q.png"></div>
                      <div>{{ item.pro_info.title  }}</div>
                    </div>
                    <div class="tuwen-btn"
                         v-if="item.pro_info.tuwen"
                         @click="openTuwen(chatIndex)">
                      <div class="inner-btn">查看图文流程</div>
                      <div class="img"><img src="../assets/robot/arrow-r-orange.png"> </div>
                    </div>
                    <div class="answer-box flex">
                      <div class="icon"> <img src="../assets/robot/newimage/A.png"></div>
                      <div class="answer">
                        <div v-html="$options.filters.hrefStyl(item.pro_info.answer)"
                             id="main-info"></div>
                      </div>
                    </div>
                    <div>
                      <section v-if="platform == 'app'">
                        <div class="other-info"
                             v-if="item.pro_info.supplement">
                          <div class="item"
                               @click="openArticle(supple_item.path)"
                               v-for="(supple_item,supple_index) in item.pro_info.supplement"
                               :key="supple_index">
                            {{supple_item.name}}
                          </div>
                        </div>
                      </section>

                      <section v-else>
                        <div class="other-info"
                             v-if="item.pro_info.supplement_h5">
                          <div class="item"
                               @click="openArticle(supple_item.path)"
                               v-for="(supple_item,supple_index) in item.pro_info.supplement_h5"
                               :key="supple_index">
                            {{supple_item.name}}
                          </div>
                        </div>
                      </section>
                    </div>

                  </article>

                  <div class="attitude"
                       v-if="!(chatIndex < fisrtTimeIndex&&item.attitude == '无')">
                    <div v-if="
                       item.attitude==='无'">
                      <img @click="
                       attitudeUp(chatIndex,item.pro_info.id,item.pro_info.title)"
                           class="attitude-icon"
                           src="../assets/robot/feedback-up.png"
                           mode=""></img>
                      <img @click="attitudeDown(chatIndex,item.pro_info.id,item.pro_info.title)"
                           class="attitude-icon"
                           src="../assets/robot/feedback-down.png"
                           mode=""></img>
                    </div>
                    <div v-else>
                      <img v-if="item.attitude === '满意'"
                           class="attitude-icon"
                           src="../assets/robot/feedback-up-active.png"
                           mode=""></img>
                      <img v-else
                           class="attitude-icon"
                           src="../assets/robot/feedback-down-active.png"
                           mode=""></img>
                    </div>
                  </div>
                </section>
                <!-- 问题答案 -->

                <!-- 常见问题 -->
                <section class="commonQ all-border"
                         v-if="(item.pro_info.problem_cj_h5 && platform === 'h5') || (item.pro_info.problem_cj && platform === 'app')">
                  <div class="commonQ-H">
                    <img class="commonQ-H-Q"
                         src="../assets/robot/comQ-Q.png"
                         mode=""></img>
                    <img class="commonQ-H-comQ"
                         src="../assets/robot/newimage/icon-cj.png"
                         mode=""></img>
                  </div>
                  <div class="commonQ-C">

                    <section v-if="platform == 'h5'">
                      <div class="commonQ-C-i flex between"
                           v-for="(cjItem,cjIndex) in item.pro_info.problem_cj_h5"
                           @click="query(cjItem)"
                           v-if="cjItem"
                           :key="cjIndex">
                        <div class="flex">
                          <div class="commonQ-C-i-styl"></div>
                          <div class="commonQ-C-i-txt">{{cjItem}}</div>
                        </div>
                        <img class="commonQ-C-i-goto"
                             src="../assets/robot/guess-goto.png"
                             mode=""></img>
                      </div>
                    </section>

                    <section v-else>
                      <div class="commonQ-C-i flex between"
                           v-for="(cjItem,cjIndex) in item.pro_info.problem_cj"
                           @click="query(cjItem)"
                           v-if="cjItem"
                           :key="cjIndex">
                        <div class="flex">
                          <div class="commonQ-C-i-styl"></div>
                          <div class="commonQ-C-i-txt">{{cjItem}}</div>
                        </div>
                        <img class="commonQ-C-i-goto"
                             src="../assets/robot/guess-goto.png"
                             mode=""></img>
                      </div>
                    </section>

                  </div>
                </section>
                <!-- 常见问题 -->

              </article>
              <!-- 问题答案 + 常见问题 -->

              <!-- 关联推荐 -->
              <article v-if="item.type == 'answer1'"
                       style="position:relative">
                <div class="recommend all-border">
                  <div v-if="item.pro_info.answer"
                       class="recommend-H">
                    <div v-html="$options.filters.hrefStyl(item.pro_info.answer)"
                         :selectable="true"></div>
                  </div>

                  <div v-else>
                    <span>为了能好的解决您的问题，请选择具体要问的事情</span>
                  </div>

                  <div class="recommend-C">

                    <section v-if='platform === "app"'>
                      <div class="recommend-C-i flex between"
                           v-for="(item,index) in item.pro_info.problem_tj"
                           :key="index">
                        <div class="flex"
                             @click="query(item)">
                          <div class="recommend-C-i-styl"></div>
                          <div class="recommend-C-i-txt">{{item}}</div>
                        </div>
                        <img class="recommend-C-i-goto"
                             src="../assets/robot/guess-goto.png"
                             mode=""></img>
                      </div>
                    </section>

                    <section v-else>
                      <div class="recommend-C-i flex between"
                           v-for="(item,index) in item.pro_info.problem_tj_h5"
                           :key="index">
                        <div class="flex"
                             @click="query(item)">
                          <div class="recommend-C-i-styl"></div>
                          <div class="recommend-C-i-txt">{{item}}</div>
                        </div>
                        <img class="recommend-C-i-goto"
                             src="../assets/robot/guess-goto.png"  /></img>
                      </div>
                    </section>
                  </div>
                </div>
                <!-- 用户的态度 -->
                <div class="attitude"
                     v-if="!(chatIndex < fisrtTimeIndex&&item.attitude == '无')">
                  <div v-if="item.attitude === '无'">
                    <img @click="attitudeUp(chatIndex,item.pro_info.id,item.pro_info.title)"
                         class="attitude-icon"
                         src="../assets/robot/feedback-up.png"
                         mode=""></img>
                    <img @click="attitudeDown(chatIndex,item.pro_info.id,item.pro_info.title)"
                         class="attitude-icon"
                         src="../assets/robot/feedback-down.png"
                         mode=""></img>
                  </div>
                  <div v-else>
                    <img v-if="item.attitude === '满意'"
                         class="attitude-icon"
                         src="../assets/robot/feedback-up-active.png"
                         mode=""></img>
                    <img v-else
                         class="attitude-icon"
                         src="../assets/robot/feedback-down-active.png"
                         mode=""></img>
                  </div>
                </div>
                <!-- 用户的态度 -->
              </article>
              <!-- 关联推荐 -->

              <article v-if="item.type == 'oldAnswer'"
                       class="oldAnswer all-border">
                <!-- 旧答案 -->
                <div v-html="$options.filters.hrefStyl(item.content)"></div>
                <!-- 旧答案 -->
              </article>

              <!-- 旧关键词 -->
              <article v-if="item.type == 'oldRecom'"
                       class="oldRecom">
                <div>为您查到了以下内容</div>
                <div class="oldRecom-c-i"
                     v-for="(c_item,c_index) in item.content"
                     :key="c_index"
                     @click="getOldRobot(c_item.group_name,c_item.id)">
                  {{c_item.group_name}}
                </div>
              </article>
              <!-- 旧关键词 -->

              <!-- <article v-if="item.type == 'unfound'"
                       class="robot-say all-border">
                <div v-html="item.answer"></div>
              </article> -->

              <!-- 机器人消息 -->
              <article v-if="item.type == 'say'"
                       class="robot-say all-border">
                <div v-html="item.content"></div>
              </article>
              <!-- 机器人消息 -->

            </section>


            <section v-if="item.target === 'u'" class="user  align-start user_info" >
              <div class="user_message">
                <div class="user-say">{{item.message}}</div>
              </div>
              <div class="loading_answer" v-if="item.show_sikao==true" >
                正在思考中...
              </div> 
            </section>

            <!-- 反馈 -->
            <article v-if="item.target == 'feedback'">
              <div class="feedback">
                <section class="feedback-H">
                  <img class="feedback-H-icon"
                       src="../assets/robot/feed-edit.png"
                       mode="" />
                  <span class="feedback-H-txt">意见反馈</span>
                </section>
                <section class="feedback-C ">
                  <section class="feedback-C-t flex between">
                    <div class="feedback-C-t-i flex center"
                         :class="{'feedback-C-i-active': item.feedBack.reasonIndex === reasonIndex }"
                         v-for="(reasonItem,reasonIndex) in reason"
                         :key="reasonIndex"
                         @click="reasonChange(chatIndex,reasonIndex)">{{reasonItem}}</div>
                  </section>
                  <section class="feedback-C-b">
                    <textarea maxlength="100"
                              v-model="item.feedBack.content"
                              placeholder="选填" />
                    <div class="feedback-num">
                      <span>{{item.feedBack.content.length}}</span>
                      <span>/100</span>
                    </div>
                  </section>
                </section>
                <div class="feedback-F flex center"
                     @click="submitFeedBack(chatIndex,item.feedBack.feedbackId,item.feedBack.reasonIndex, item.feedBack.content) ">
                  提交</div>
              </div>
            </article>
            <!-- 反馈 -->
          </section>
        </section>
      </section>

      <section>
        <!-- 联想词 -->
        <section v-show="inputTips&&inputList.length > 0"
                 class="input-tips">
          <div class="input-tips-i"
               v-for="(item,index) in inputList"
               :key="index"
               @click="userSend(item.title,item)"
               v-html="$options.filters.heightline(item,fenci)">
          </div>
        </section>
        <!-- 联想词 -->

        <!-- 搜索框 -->
        <section class="input flex">
          <el-input v-model="keyword"
                    @keyup.enter.native="userSend(keyword)"
                    placeholder="请输入想了解的问题">
          </el-input>
          <div class="sendButton flex center"
               @click="userSend(keyword)">发送</div>
        </section>
        <!-- 搜索框 -->

      </section>

    </article>

  </section>
</template>

<script>
import util from "../util/util.js";
import tuwen from "./new-robot/tuwen/tuwen.vue";
import cateBox from "./new-robot/cateBox/cateBox.vue";
import downFresh from "./new-robot/downFresh/downFresh.vue"; //下拉获取历史记录的组件
import { getRandomAlph } from "@/util/tool.js";

export default {
  name: "newRobot",
  components: {
    tuwen,
    cateBox,
    downFresh,
  },
  data() {
    return {
      currentCate: "",

      show: false,
      nowSeeImage: "",
      keyword: "",
      initWord: "",
      // cityname: "深圳",
      chatList: [],
      inputTips: false,
      inputList: [],
      fenci: [],
      feedBackList: [],
      unKnowList: [],
      reason: ["不是我想要的答案", "内容看不懂", "答案方法不可行"],

      sid: "",
      allSid: "", //保存全部会话的sid
      reply_num: 0,
      recept_time: 0,
      noresult_num: 0,
      good_num: 1,
      art_num: 0,
      startTime: 0,
      endTime: 0,

      guess_num: 0,
      card_zt_num: 0,
      article_num: 0,
      keywords_num: 0,
      list_num: 0,
      answer_num: 0,

      guessList: [],

      defaultReply:
        "抱歉，暂时没有找到你想要的答案，建议找你添加的小编微信咨询一下哈，辛苦啦～",
      isMobile: null,
      graphicContent: [],
      graphicData: {
        user_input: "",
        cityname: "",
        pid: 0,
      },
      openChatindex: 0,
      cateList: [],

      cate_id: "",
      cate_name: "",

      iconList: {
        疫情: require("@/assets/robot/cateReply/cate1-1.png"),
        办事: require("@/assets/robot/cateReply/cate1-2.png"),
        教育: require("@/assets/robot/cateReply/cate1-3.png"),
        交通: require("@/assets/robot/cateReply/cate1-4.png"),
        休闲: require("@/assets/robot/cateReply/cate1-5.png"),
        旅游: require("@/assets/robot/cateReply/cate1-6.png"),
      },

      platform: "h5",
      oldHistory: [], //历史的聊天记录
      scrollToken: true, //是否可以滑到底部
      showtime: false,
      timeStamp: 0,
      topOverTips: "到底啦，您暂无更多历史消息",
      fisrtTimeIndex: -1, //用来控制历史记录中的评价按钮不显示.
      chatToken: "",
      leadIdArr: [],
    };
  },
  props: {
    cityname: String,
    gid: String,
  },
  mounted() {
    //mounted的时候，处理上一次的会话记录和以前的历史记录
  },
  watch: {
    cityname: {
      async handler(newVal, oldVal) {
        this.platform = localStorage.getItem("platform") || "h5";
        if (this.showCate()) {
          this.chatList.push({ target: "cate" });
        }
        await this.getCate();
        this.initHistoryInfo();
        this.getInit();
        this.isMobile = this._isMobile();
        this.$store.commit("changeIsMobile", this.isMobile);
      },
    },

    keyword(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getInputTips();
      }
      newVal === "" ? (this.inputTips = false) : (this.inputTips = true);
      this.$forceUpdate();
    },

    chatList(newVal, oldVal) {
      this.scrollToBottom();
      for (let i = 0; i < this.chatList.length; i++) {
        //如果chatList变化，则fisrtTimeIndex也跟着变化，用来控制历史记录中的评价按钮不能显示
        if (this.chatList[i].timeStamp == this.timeStamp) {
          this.fisrtTimeIndex = i;
          break;
        }
      }
      this.$nextTick(() => {
        this.addEventListenToImg();
      });
    },
  },
  filters: {
    heightline(data, fenci) {
      let val = data.title;
      if (data.type) {
        val = `(文章)${val}`;
      }
      if (fenci.length) {
        fenci.forEach((item) => {
          if (val.includes(item)) {
            val = val.replace(
              item,
              `<span style='color:#FF6600' >${item}</span>`
            );
          }
        });
      }
      return val;
    },
    hrefStyl(value) {
      value = value.replace(/<a/g, "<a style='color:#71aaff;'");
      value = value.replace(/<img/g, "<img style='width:100%;'");
      return value;
    },
  },
  methods: {
    initHistoryInfo() {
      this.timeStamp = Date.now(); //记录这次会话打开的时候的时间戳，也是用来作为保存聊天记录的起止位置的标记

      this.chatToken = this.timeStamp + "_" + getRandomAlph({ num: 5 });
      console.log(this.chatToken);
      let dateTime = util.getNowDateTime();
      this.sessionTime = dateTime;
      this.chatList.push({
        target: "time",
        type: "time",
        time: dateTime,
        timeStamp: this.timeStamp,
      });
      // 如果有userid并且不是test，就去获取聊天记录
      if (!localStorage.isTest) {
        this.showtime = true;
        this.getHistory();
      }
    },

    // 组件挂载完成时 获取并处理缓存的历史聊天记录，
    // 缓存中有oldHistory和newHistory两个历史记录
    // oldHistory 当前会话以前的记录，newHistory是当前会话的。
    // 每次mounted的时候将newHistory的内容 unshift到oldHistory中，并更新缓存中的oldHistory，将newHistory重新置为[]
    // 然后newHistory就用来保存此次会话的记录
    getHistory() {
      let oldHistory = localStorage.getItem("oldHistory");
      let newHistory = localStorage.getItem("newHistory");
      let over30Flag = 0;
      let gap = 30 * 24 * 60 * 60 * 1000;
      //   let gap = 20 * 1000;

      if (oldHistory) {
        let temp_oldHistory = JSON.parse(oldHistory);
        oldHistory = temp_oldHistory;
      } else {
        localStorage.setItem("oldHistory", JSON.stringify([]));
        oldHistory = [];
      }

      //如果上次退出的时候的聊天记录有的话，则取出来，放到oldHistory中,将newHistory置为空
      newHistory = JSON.parse(newHistory);
      if (newHistory) {
        localStorage.setItem("newHistory", JSON.stringify("")); //置空
        //将新的放到旧的里面
        oldHistory.unshift(newHistory);
        localStorage.setItem("oldHistory", JSON.stringify(oldHistory));
      }

      let lastHistory = [];
      let oldIndex = -1;
      oldHistory.map((item, index) => {
        if (item.citycode == localStorage.citycode) {
          if (this.timeStamp - gap < item.chat[0].timeStamp) {
            lastHistory.push(item.chat);
          } else if (
            item.chat[0].timeStamp &&
            this.timeStamp - gap >= item.chat[0].timeStamp
          ) {
            oldIndex == -1 ? (oldIndex = index) : "";
            over30Flag = true;
            localStorage.setItem("over30", "1");
          }
        }
      });
      over30Flag = localStorage.over30 == "1" ? "1" : 0;
      this.oldHistory = lastHistory;
      if (oldIndex != -1) {
        localStorage.setItem(
          "oldHistory",
          JSON.stringify(oldHistory.slice(0, oldIndex))
        );
      }

      this.getAllHistory({ over: over30Flag }); //将全部的历史记录都放到页面中
    },

    // 将全部的历史记录都放到页面中
    getAllHistory(data) {
      this.oldHistory.forEach((item) => {
        let arr = item.concat(this.chatList);
        this.chatList = arr;
      });
      if (this.oldHistory.length) {
        let obj = {
          target: "topOver",
        };
        this.chatList.unshift(obj);
      }
      //有超过30天的消息记录
      if (data.over && this.oldHistory.length) {
        this.topOverTips =
          "到底啦，您暂无更多历史消息，最多为您保留30天以内的消息记录";
      }
    },

    // 缓存此次会话的聊天记录 newHistory,
    saveHistory() {
      if (!this.showtime) return;

      let timeIndex = -1; //标记此次打开会话的时间戳

      this.chatList.forEach((item, index) => {
        if (item.timeStamp === this.timeStamp) {
          timeIndex = index;
        }
        // if(item.target=="u"){
        //     item.show_sikao=false 
        // }
      });

      let time = this.chatList[timeIndex];
      //   console.log("时间", time);
      let tempChatList = JSON.stringify(this.chatList);
      tempChatList = JSON.parse(tempChatList); //深拷贝
      tempChatList = tempChatList.slice(timeIndex); //截取到时间位置

      let initIndex = -1;
      tempChatList.some((item, index) => {
        if (item.type == "init") {
          initIndex = index;
          return true;
        }
      });
      //   console.log(initIndex);

      tempChatList.splice(initIndex, 1);
      let tempObj = {
        citycode: localStorage.getItem("citycode"),
        chat: tempChatList,
      };
      //   console.log("去掉初始化数据后的记录", tempChatList);
      localStorage.setItem("newHistory", JSON.stringify(tempObj));
    },

    /**
     * 选择二级目录
     * @method show
     */
    showCate() {
      return this.platform === "h5" && this.cityname === "武汉";
    },
    /**
     * 选择二级目录
     * @method changeCateQ
     */
    changeCateQ(i) {
      let length = this.chatList[i].pro_list.length;
      let minIndex = this.chatList[i].minIndex;
      minIndex + 7 < length
        ? (this.chatList[i].minIndex = minIndex + 6)
        : (this.chatList[i].minIndex = 0);
    },
    /**
     *  获取常见问题
     * @method getCateList
     */
    async getCateList() {
      this.chatList.push({
        target: "u",
        message: this.cate_name,
        time: this.getCurrentTime(),
        sendstatus: true,
        waitStatus: false,
        first: true,
      });

      let data = {
        action: "problem_faq",
        cityname: this.cityname,
        id: this.cate_id,
        name: this.cate_name,
      };
      let res = await util.request(data);
      if (res.data.state === 1) {
        let problem_cj = res.data.data.problem_cj;

        this.chatList.push({
          target: "r",
          type: "cateCommon",
          pro_list: problem_cj,
          minIndex: 0,
          cateType: this.currentCate,
          time: this.getCurrentTime(),
        });
      }
      this.saveHistory();
    },
    /**
     * 选择二级目录
     * @method selectCate2
     */
    selectCate2(e) {
      this.currentCate = this.cateList[e.index1].name;
      this.cate_name = this.cateList[e.index1].children[e.index2].name;
      this.cate_id = this.cateList[e.index1].children[e.index2].id;
      this.getCateList();
    },
    /**
     * 选择一级目录
     * @method changeCate
     */
    changeCate(i) {
      this.currentCate = this.cateList[i].name;
      this.cate_name = this.cateList[i].name;
      this.cate_id = this.cateList[i].id;

      this.getCateList();
    },
    async getCate() {
      let data = {
        action: "cate_list",
        cityname: this.cityname,
      };
      let res = await util.request(data);
      if (res.data.state) {
        this.cateList = res.data.data;
      } else {
        this.cateList = [{}];
      }
    },

    /* 2022-07-15
     * 对话中的图片，点击可以放大查看
     * 石榴
     */
    addEventListenToImg() {
      //添加事件代理
      let main_info_box = document.querySelectorAll("#main-info");
      if (main_info_box && main_info_box.length > 0) {
        //每次成功询问的时候，给最新内容中的照片添加监听
        main_info_box[main_info_box.length - 1].addEventListener(
          "click",
          (event) => {
            if (event.target.tagName.toLowerCase() === "img") {
              let src = event.target.src;
              //如果是图片标签
              //   console.log("点击了图片", src);
              this.nowSeeImage = src;
            }
          }
        );
      }
    },

    hideImage() {
      this.nowSeeImage = "";
    },

    closeTuwen(e) {
      if (e.feedBackStatus && e.content) {
        this.chatList[this.openChatindex].tuwenStatus = e.feedBackStatus;
        this.chatList[this.openChatindex].pro_info.tuwen.content = e.content;
      }
    },
    openTuwen(chatIndex) {
      this.openChatindex = chatIndex;
      this.graphicData.cityname = this.cityname;
      this.graphicData.pid = this.chatList[chatIndex].pro_info.id;
      this.graphicData.tuwenStatus = this.chatList[chatIndex].tuwenStatus;
      this.graphicData.standardQ = this.chatList[chatIndex].pro_info.title;
      this.graphicData.user_input = this.chatList[chatIndex - 1].message;
      this.graphicData.content =
        this.chatList[chatIndex].pro_info.tuwen.content;
      this.$refs.tuwen.switchGra("open");
    },
    /**
     * 返回底部
     * @method scrollToBottom
     */
    scrollToBottom() {
      if (this.scrollToken) {
        //如果是加载历史记录，则不需要滑动至底部
        this.$nextTick(() => {
          this.$refs.main.scrollTop = this.$refs.content.scrollHeight;
        });
      } else {
        return;
      }
    },
    /**
     * 接待时间
     * @method getReply_time
     */
    getReply_time() {
      this.endTime = new Date().getTime();
      this.recept_time = Math.ceil((this.endTime - this.startTime) / 1000);
      let reply_num = 0;
      this.chatList.forEach((item) => {
        if (item.hasOwnProperty("target")) {
          if (
            item.target === "r" &&
            item.type.search("standartip") === -1 &&
            item.type !== "tipinputplace"
          ) {
            reply_num = reply_num + 1;
          }
        }
      });
      this.reply_num = reply_num - 1;
    },

    async sendStatistical() {
      // console.log("统计接口========", this.unKnowList);
      this.getReply_time();
      let data = {
        action: "statistic",
        cityname: this.cityname,
        platform: "h5",
        sid: this.sid,
        //回复次数，这里刚刚进来的时候就会发送一次，但是刚刚进来的时候，虽然发送了欢迎语，
        //但是reply_num仍然是0，所以改成如果是0，则发送1
        guess_num: this.guess_num,
        reply_num: this.reply_num,
        recept_time: this.recept_time,
        noresult_num: this.noresult_num,
        good_num: this.good_num,
        art_num: this.art_num,
        card_zt_num: this.card_zt_num,
        article_num: this.article_num,
        keywords_num: this.keywords_num,
        list_num: this.list_num,
        answer_num: this.answer_num,
        channel: localStorage.channel,
      };
      let res = await util.request(data, "post");
      if (res.data.state) {
        if (res.data.data.hasOwnProperty("sid")) {
          this.sid = res.data.data.sid;
        }
      }
    },

    /**
     * 判断设备
     * @method _isMobile
     */
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      if (flag) {
        // console.log("是移动端");
      }
      const clientWidth = document.body.clientWidth;
      // console.log("是移动端", clientWidth);
      // 未匹配到用户设备，再次根据屏幕分辨率判断是否为移动端
      if (!flag) {
        const clientWidth = document.body.clientWidth;
        // console.log("不是移动端");
        // console.log("屏幕宽度", clientWidth);
        if (clientWidth < 610) {
          flag = "mobile";
        }
      }
      return flag;
    },
    /**
     * 数据转义
     * @method html2Escape
     */
    html2Escape(str) {
      return str.replace(/[<>&"]/g, function (c) {
        return {
          "<": "&lt;",
          ">": "&gt;",
          "&": "&amp;",
          '"': "&quot;",
        }[c];
      });
    },
    /**
     * 简化聊天记录
     * @method simplifyChatList
     */
    simplifyChatList() {
      //   console.log("simplifyChatList", this.chatList);
      let content = [];

      let tempChatList = this.chatList.slice(this.fisrtTimeIndex);

      tempChatList.forEach((i) => {
        if (i.target === "u") {
          content.push(i);
        } else if (i.target === "r") {
          switch (i.type) {
            case "article":
              content.push({
                target: "r",
                type: "article",
                articleInfo: i.articleInfo,
                time: i.time,
              });
              break;
            case "relevantQ":
              let pro_list = [];
              i.pro_list.forEach((item) => {
                let title = item.title;
                if (item.hasOwnProperty("type")) {
                  title = `(文章)${title}`;
                }
                pro_list.push(title);
              });
              content.push({
                attitude: i.attitude,
                target: "r",
                type: "relevantQ",
                pro_list: pro_list,
                minIndex: i.minIndex,
                time: i.time,
              });
              break;
            case "answer":
              content.push({
                attitude: i.attitude,
                target: "r",
                type: "answer",
                supplement: i.pro_info.supplement_h5,
                title: i.pro_info.title,
                answer: this.html2Escape(i.pro_info.answer),
                problem_cj: i.pro_info.problem_cj_h5,
                time: i.time,
                tuwenStatus: 0,
              });

              break;
            case "answer1":
              content.push({
                attitude: i.attitude,
                target: "r",
                type: "answer1",
                answer: this.html2Escape(i.pro_info.answer),
                problem_tj: i.pro_info.problem_tj_h5,
                time: i.time,
              });
              break;
            case "oldRecom":
              let R_list = [];
              i.content.forEach((item) => {
                R_list.push(item.group_name);
              });
              content.push({
                target: "r",
                type: "oldRecom",
                pro_list: R_list,
                time: i.time,
              });
              break;
            case "oldAnswer":
              content.push({
                target: "r",
                type: "oldAnswer",
                content: this.html2Escape(i.content),
                time: i.time,
              });
              break;
            case "cateCommon":
              content.push({
                target: "r",
                type: "cateCommon",
                ...i,
                time: i.time,
              });
              break;
            case "standardgoout": //标准卡片
              //   console.log("出行卡片", i);
              let arriveInfo = [];
              i.arriveInfo.forEach((item, index) => {
                arriveInfo.push({ title: item.title });
              });

              if (i.specialPlace) {
                i.specialPlace.zhengce = this.html2Escape(
                  i.specialPlace.zhengce
                );
              }
              content.push({
                target: "r",
                type: "standardgoout",
                leavecity: i.geli_data.leavecity[0].leavecity,
                leaveyaodian: i.geli_data.chu_leave.yaodian,
                leavedaoyu: this.html2Escape(i.geli_data.chu_leave.daoyu),
                arrivecity: i.geli_data.leavecity[0].cityname,
                arriveInfo: arriveInfo,
                specialPlace: i.specialPlace,
                time: i.time,
              });
              break;
            case "onetosomplace": //点击目的地的对应政策后，弹出的答案卡片
              content.push({
                target: "r",
                type: "onetosomplace",
                flagShowAll: i.flagShowAll,
                title: i.title,
                yaodian: i.yaodian,
                content: this.html2Escape(i.content),
                time: i.time,
              });
              break;
            case "special": //特殊地区的选择
              content.push({
                target: "r",
                type: "special",
                time: i.time,
                specialPlaceArr: i.specialPlaceArr,
              });
              break;

            case "tipinputplace": //提示输入地区
              content.push({
                ...i,
              });
              break;
            case "standartip1": //提示去查看疫情等级
              content.push({
                ...i,
              });

              break;
            case "standartip2": // 提示参考格式
              content.push({
                ...i,
              });
              break;
            case "standartip3": // 更多出行政策点击 出行政策
              content.push({
                ...i,
              });
              break;

            case "unfound":
              content.push({
                target: "r",
                type: "unfound",
                answer: this.html2Escape(i.answer),
                time: i.time,
              });
              break;
            case "noplace":
              content.push({
                target: "r",
                type: "noplace",
                answer: this.html2Escape(i.answer),
                time: i.time,
              });
              break;
            case "say":
              content.push(i);
              break;
          }
        }
      });
      return content;
    },

    /**
     * 保存记录
     * @method saveChatList
     */
    async saveChatList() {
      this.saveALLSettion();
      //   console.log("-----------------", this.unKnowList);
      if (this.unKnowList.length || this.feedBackList.length) {
        let content = this.simplifyChatList();
        let data = {
          action: "reply_log",
          cityname: this.cityname,
          openid: "H5用户",
          content: JSON.stringify(content),
          unknown_ids: this.unKnowList.toString(),
          fankui_ids: this.feedBackList.toString(),
          platform: "h5",
        };

        let res = await util.request(data, "post");
      }
    },

    /**
     * 保存所有聊天会话  ——  全部会话功能
     * @method saveALLSettion
     */
    async saveALLSettion() {
      let content = this.simplifyChatList();
      let duration = Math.ceil((new Date().getTime() - this.startTime) / 1000);
      let round = 0;
      content.forEach((i) => i.target === "u" && round++);
      if (round > 0) {
        let data = {
          action: "reply_all_log",
          cityname: this.cityname,
          openid: "",
          round: round,
          duration: duration,
          session_at: this.getCurrentTime("second"),
          content: JSON.stringify(content),
          platform: "h5",
        };
        //如果有allSid，就传过去，后端就对这个会话进行数据更新
        //如果没有sid，后端则创建新的会话数据，返回给我sid
        if (this.allSid) {
          data.sid = this.allSid;
        }
        // console.log(data);
        let res = await util.request(data, "post");
        // console.log(res.data);
        //第一次发送过去的时候，获得后端那边生成的sid,
        //下一次请求接口的时候，就把这个sid传过去，让后端对这个sid的会话进行这条会话的round、duration、content的更新
        if (res.data.data.sid) this.allSid = res.data.data.sid;

        // console.log("数据发送完毕");
      }
    },

    /**
     * 提交反馈
     * @method submitFeedBack
     */
    async submitFeedBack(i, feedbackId, reasonIndex, content) {
      let title;
      reasonIndex === -1 ? (title = "") : (title = this.reason[reasonIndex]);

      try {
        let data = {
          action: "fankui_text",
          fankui_id: feedbackId,
          title: title,
          content: content,
          cityname: this.cityname,
          platform: "h5",
        };
        let res = await util.request(data);
        this.chatList.splice(i, 1);
      } catch (e) {
        this.chatList.splice(i, 1);
      }
    },

    /**
     * 问题反馈  （选择原因）
     * @method reasonChange
     */
    reasonChange(chatIndex, reasonIndex) {
      this.chatList[chatIndex].feedBack.reasonIndex = reasonIndex;
    },
    tuwenfeedback(e) {
      this.feedBackList.push(e);
      this.saveChatList();
    },

    /**
     * 问题反馈  （好评）
     * @method attitudeUp
     */
    async attitudeUp(i, pid, title) {
      this.chatList[i].attitude = "满意";
      let userSay = this.chatList[i - 1].message;

      this.chatList.push({
        target: "r",
        type: "say",
        content: "感谢您的点赞，您的鼓励是我前进最大的动力~",
        time: this.getCurrentTime(),
      });
      this.saveHistory();

      //问题反馈数据填充
      let data = {
        action: "fankui",
        title: title,
        pid: pid,
        answer_res: "满意",
        cityname: this.cityname,
        user_input: userSay,
        platform: "h5",
      };
      let res = await util.request(data);
      res.data.state === 1 && this.feedBackList.push(res.data.data.id);
      this.saveChatList();
    },
    /**
     * 问题反馈  （差评）
     * @method attitudeDown
     */
    async attitudeDown(i, pid, title) {
      this.chatList[i].attitude = "不满意";
      let userSay = this.chatList[i - 1].message;

      let data = {
        action: "fankui",
        title: title,
        pid: pid,
        answer_res: "不满意",
        cityname: this.cityname,
        user_input: userSay,
        platform: "h5",
      };

      let res = await util.request(data);

      if (res.data.state) {
        let feedbackId = res.data.data.id;
        this.feedBackList.push(feedbackId);
        this.chatList.push({
          target: "r",
          type: "say",
          content:
            "抱歉，给您带来不好的体验,我会继续改进,下次为您提供更好的服务。",
          time: this.getCurrentTime(),
        });
        this.saveHistory();
        this.chatList.push({
          target: "feedback",
          feedBack: {
            feedbackId: feedbackId,
            reasonIndex: -1,
            content: "",
            time: this.getCurrentTime(),
          },
        });
        this.good_num = 0;
        this.sendStatistical();
        this.saveChatList();
      }
    },
    /**
     * 猜你想问（换一换）
     * @method guessChange
     */
    guessChange(i) {
      let guessLength = this.chatList[i].guess.length;
      let minIndex = this.chatList[i].minIndex;
      minIndex + 6 < guessLength
        ? (this.chatList[i].minIndex = minIndex + 6)
        : (this.chatList[i].minIndex = 0);
    },
    /**
     * 相关推荐  （换一换）
     * @method releChange
     */
    releChange(i) {
      let listLength = this.chatList[i].pro_list.length;
      let minIndex = this.chatList[i].minIndex;
      minIndex + 5 < listLength
        ? (this.chatList[i].minIndex = minIndex + 5)
        : (this.chatList[i].minIndex = 0);
    },

    /**
     * 联想词列表获取
     * @method getInputTips
     */
    async getInputTips() {
      try {
        this.FenCi();
        let data = {
          action: "search_kwd",
          keywords: this.keyword,
          cityname: this.cityname,
          cate_id: this.cate_id,
          cate_name: this.cate_name,
          platform: "h5",
        };
        let res = await util.request(data);
        res.data.state
          ? (this.inputList = res.data.data)
          : (this.inputList = []);
      } catch (err) {
        // console.log("联想词功能报错:", err);
      }
    },
    /**
     * 联想词分词功能
     * @method FenCi
     */
    async FenCi() {
      let data = {
        action: "fenci",
        keywords: this.keyword,
        cityname: this.cityname,
      };
      let res = await util.request(data);
      this.fenci = res.data.data;
    },
    /**
     * 打开链接
     * @method openArticle
     */
    openArticle(e) {
      window.open(e, "_blank");
    },
    /**
     * 获取默认反馈
     * @method getCurrentTime
     */

    getCurrentTime(type = "minute") {
      let currentTime = new Date(+new Date() + 8 * 3600 * 1000).toISOString();
      currentTime = currentTime.split("T");
      let date = currentTime[0];
      let time;
      type === "minute"
        ? (time = `${currentTime[1].split(":")[0]}:${
            currentTime[1].split(":")[1]
          }`)
        : (time = `${currentTime[1].split(":")[0]}:${
            currentTime[1].split(":")[1]
          }:${currentTime[1].split(":")[2].split(".")[0]}`);
      return `${date} ${time}`;
    },

    /**
     * 猜你想问数据
     * @method getInit
     */
    async getInit() {
      let data = {
        action: "cnxw_new",
        cityname: this.cityname,
        platform: this.platform,
        reply: this.gid,
      };
      let res = await util.request(data);
      // console.log("猜你想问数据getInit--------", res);
      let guess = [];
      if (res.data.state === 1) {
        guess = res.data.data;
        this.guessList = guess;
      }
      this.general(guess);
    },

    /**
     * 通用数据
     * @method general
     */
    async general(guess) {
      let data = {
        action: "general",
        cityname: this.cityname,
        platform: this.platform,
        reply: this.gid,
      };
      let res = await util.request(data);
      //   console.log("初始对话：-----------", res.data);
      res.data.state && res.data.data.welcome
        ? (this.initWord = res.data.data.welcome)
        : (this.initWord = `hello，你好，我是小宝，是你在${this.cityname}的生活小助手，有啥问题尽管问哈~`);
      res.data.state && res.data.data.answer
        ? (this.defaultReply = res.data.data.answer)
        : (this.defaultReply =
            "抱歉，暂时没有找到你想要的答案，建议找你添加的小编微信咨询一下哈，辛苦啦～");

      this.chatList.push({
        target: "r",
        type: "init",
        guess: guess,
        initWord: this.initWord,
        minIndex: 0,
        time: this.getCurrentTime(),
      });
      // console.log("猜你想问的数据", guess);
      this.startTime = new Date().getTime();
      this.sendStatistical();
      if (localStorage.getItem("question")) {
        this.userSend(localStorage.getItem("question"));
      }
      this.$forceUpdate();
    },

    //获取精准推荐
    async getNiceRecom(info) {
      // console.log("获取精准推荐");
      this.chatList.push({
        target: "u",
        message: info.title + "相关问题",
        time: this.getCurrentTime(),
        sendstatus: true,
        waitStatus: false,
        first: true,
      });

      this.chatList.push({
        target: "r",
        type: "relevantQ",
        pro_list: info.content,
        minIndex: 0,
        time: this.getCurrentTime(),
      });
    },

    //判断 是否需要携带引导id传递给后端
    //如果最后一个消息内容是包含引导id的，并且是新的提问，则checkYindao函数返回引导id
    checkYindao() {
      let lastItem = this.chatList[this.chatList.length - 1];
      if (lastItem.yindaoId) {
        return lastItem.yindaoId;
      }
      return false;
    },

    //处理得到的是引导的内容
    dealYindao(res, leadId) {
      let type = res.data.data.error_type;
      let yindaoId = res.data.data.lead_id || leadId; //从返回的结果中得到引导的id和如果连续引导会携带的相同的引导id
      // console.log("引导id", yindaoId);
      let weizhiId = res.data.data.unknown_id; //未知问题id
      //   console.log(weizhiId, this.unKnowList);
      let chat = {
        target: "r",
        type: "say",
        time: this.getCurrentTime(),
        yindaoId,
      };
      if (type == 1 || type == 2) {
        //过长
        chat.content = res.data.data.error_msg;
      } else if (res.data.data.search_data.length) {
        //多个问题
        // if (res.data.data.search_data.length) {
        chat.pro_list = res.data.data.search_data;
        chat.minIndex = 0;
        chat.type = "relevantQ";
        // } else {
        //   chat.content = res.data.data.error_msg;
        // }
      }
      this.chatList.push(chat);

      //对unKnowList进行去重
      this.unKnowList.push(weizhiId);
      // console.log("保存********");
      this.saveHistory();
      this.saveChatList();
      this.sendStatistical();
    },

    //   修改数据库中的引导信息
    async checkchangeLeadInfo(info = {}) {
      let data = {
        action: "lead_result",
        cityname: this.cityname,
        lead_id: info.lead_id,
        platform: "h5",
      };
      // console.log(info);
      if (info.type == "unknown_id") {
        //如果是未知问题，则请求接口，修改引导信息,更新引导信息中的未知问题
        console.log("失败了");
        data.is_success = 0;
        let res = await util.request(data);
        this.noresult_num = this.noresult_num - 1;
        console.log("失败了也减一", this.noresult_num);
        this.saveChatList();
        this.sendStatistical();
        // console.log("修改引导的数据", res);
      } else {
        //如果不是未知问题，则请求接口，修改引导信息为引导成功,并且修改无结果回复减一
        // console.log("成功了");
        data.is_success = 1;
        let res = await util.request(data);
        // console.log("修改引导的数据", res);
        this.noresult_num = this.noresult_num - 1;
        this.saveChatList();
        this.sendStatistical();
      }
    },

    // 回退引导：
    async backLead(lead_id) {
      let data = {
        action: "lead_result",
        cityname: this.cityname,
        lead_id: lead_id,
        platform: "h5",
        is_success: 0,
        has_reply: 1,
      };
      await util.request(data);
    },



    cancleSikao(sikao_id){
        for(let i = this.chatList.length-1; i>=0; i--){
            if(this.chatList[i].sikao_id==sikao_id){
                this.chatList[i].show_sikao=false;
                break;
            }
        }
    },

    /**
     * 新机器人回复(联想词 + 文本框查询)
     * @method userSend
     */
    async userSend(keyword, info = null) {  
      this.keyword = "";
      if (keyword) {
        if (this.guessList.some((item) => item.title === keyword)) {
          this.guess_num = this.guess_num + 1;
        }

        let yindaoId = this.checkYindao(); //用于判断重新的提问的问题是否需要携带引导id
        let timeStamp = Date.now(); 
        this.chatList.push({
          target: "u",
          message: keyword,
          time: this.getCurrentTime(),
          sendstatus: true,
          waitStatus: false,
          first: true,
          show_sikao:true, //用户提问后，左边机器人提示正在思考
          sikao_id:timeStamp, //标记这个提问对应的答案共用的关联id 
        }); 
        let consult = [
          "人工客服",
          "客服",
          "人工",
          "人工咨询",
          "人工服务",
          "小宝问问",
          "小宝",
          "真人",
          "小宝问问人工咨询",
        ];
        let isToArtif = consult.find((item) => {
          return item === keyword;
        });
        if (isToArtif) {
          this.chatList.push({
            target: "r",
            type: "say",
            content: "辛苦找下您添加的小编微信咨询哦~",
            time: this.getCurrentTime(),
          });
        } else {
          let article_id;
          if (info && info.type) {
            article_id = info.id;
            keyword = "";
          } else {
            article_id = "";
          }
          let data = {
            action: "reply",
            keywords: keyword,
            cityname: this.cityname,
            article_id: article_id,
            platform: this.platform,
            cate_id: this.cate_id,
            cate_name: this.cate_name,
            chat_key: this.chatToken,
          };
          if(this.sid){
                data.sid = this.sid
            }
          if (localStorage.getItem("isTest") == 1) {
            data.is_test = localStorage.getItem("isTest");
          }
          //如果info中带有引导id，则携带引导id去后端请求
          if (info && info.yindaoId) {
            //如果携带的info中已经有引导id——点击推荐的列表
            data.lead_id = info.yindaoId;
          } else {
            //判断要不要携带引导id，重新进行提问，
            if (yindaoId) {
              data.lead_id = yindaoId;
            }
          }

          try { 
            let res = await util.request(data, "post");

            this.cancleSikao(timeStamp)

            console.log("出结果")
            if (res.data.state) {
              // console.log("回复的结果", res.data.data);
              let attrList = [
                "pro_info",
                "geli_data",
                "art_info",
                "mix_list",
                "pro_list",
                "art_list",
                "error_type",
                "unknown_id",
              ];

              let attr = attrList.find((i) => i in res.data.data);

              const replyContent = {
                pro_info: () => {
                  this.answer_num = this.answer_num + 1;

                  let cate_name = "";
                  if (res.data.data.in_cate === false) {
                    this.cate_id = res.data.data.real_info.real_cate_id;
                    this.cate_name = res.data.data.real_info.real_cate_name;
                    this.currentCate = this.cate_name;
                    cate_name = this.cate_name;
                  }

                  let pro_info = res.data.data.pro_info;

                  if (pro_info.supplement) {
                    pro_info.supplement = pro_info.supplement.filter(
                      (item) => item.name !== "" && item.path !== ""
                    );

                    if (!pro_info.supplement.length) {
                      pro_info.supplement = null;
                    }
                  }

                  if (pro_info.supplement_h5) {
                    pro_info.supplement_h5 = pro_info.supplement_h5.filter(
                      (item) => item.name !== "" && item.path !== ""
                    );

                    if (!pro_info.supplement_h5.length) {
                      pro_info.supplement_h5 = null;
                    }
                  }

                  if (this.platform == "h5") {
                    pro_info.problem_tj_h5
                      ? this.chatList.push({
                          target: "r",
                          type: "answer1",
                          pro_info: pro_info,
                          attitude: "无",
                          time: this.getCurrentTime(),
                        })
                      : this.chatList.push({
                          target: "r",
                          type: "answer",
                          pro_info: pro_info,
                          attitude: "无",
                          time: this.getCurrentTime(),
                          tuwenStatus: 0,
                          cateType: cate_name,
                        });
                  } else {
                    pro_info.problem_tj
                      ? this.chatList.push({
                          target: "r",
                          type: "answer1",
                          pro_info: pro_info,
                          attitude: "无",
                          time: this.getCurrentTime(),
                        })
                      : this.chatList.push({
                          target: "r",
                          type: "answer",
                          pro_info: pro_info,
                          attitude: "无",
                          time: this.getCurrentTime(),
                          tuwenStatus: 0,
                          cateType: cate_name,
                        });
                  }

                  if (res.data.data.is_geli) {
                    //如果是和隔离相关的问题，提示隔离
                    this.chatList.push({
                      target: "r",
                      type: "standartip3",
                      info: res.data.data,
                    });
                  }
                },
                geli_data: () => {
                  this.card_zt_num = this.card_zt_num + 1;

                  if (res.data.data.geli_special !== null) {
                    //特殊地区
                    // console.log("特殊地区");
                    let specialPlaceArr = res.data.data.geli_special;
                    let geli_data = res.data.data.geli_data;
                    this.chatList.push({
                      target: "r",
                      type: "special",
                      specialPlaceArr: specialPlaceArr,
                      geli_data: geli_data,
                    });
                  } else {
                    let geli_data = res.data.data.geli_data;
                    // console.log("非特殊地区");
                    let arriveInfo = this.dealStandaerAnswer(geli_data);
                    this.pushStandardCArd(geli_data, arriveInfo);
                  }
                },
                art_info: () => {
                  this.article_num = this.article_num + 1;

                  let art_info = res.data.data.art_info;
                  this.chatList.push({
                    target: "r",
                    type: "article",
                    articleInfo: art_info,
                    attitude: "无",
                    time: this.getCurrentTime(),
                  });
                },
                mix_list: () => {

                  this.list_num = this.list_num + 1;
                  this.answer_num = this.answer_num + 1;
                  this.article_num = this.article_num + 1;

                  let mix_list = res.data.data.mix_list;
                  this.chatList.push({
                    target: "r",
                    type: "relevantQ",
                    pro_list: mix_list,
                    minIndex: 0,
                    time: this.getCurrentTime(),
                  });
                },
                pro_list: () => {
                  this.list_num = this.list_num + 1;
                  this.answer_num = this.answer_num + 1;

                  let pro_list = res.data.data.pro_list;
                  this.chatList.push({
                    target: "r",
                    type: "relevantQ",
                    pro_list: pro_list,
                    minIndex: 0,
                    time: this.getCurrentTime(),
                  });
                  if (keyword == "出行政策") {
                    //如果是和隔离相关的问题，提示隔离
                    this.chatList.push({
                      target: "r",
                      type: "tipinputplace",
                    });
                  }
                },
                art_list: () => {
                  this.list_num = this.list_num + 1;
                  this.article_num = this.article_num + 1;

                  let art_list = res.data.data.art_list;
                  this.chatList.push({
                    target: "r",
                    type: "relevantQ",
                    pro_list: art_list,
                    minIndex: 0,
                    time: this.getCurrentTime(),
                  });
                },
                //无结果回复的引导
                error_type: async () => {
                  let oldAnswer = await this.getOldRobot(keyword, "", {
                    errorType: "error_type",
                    firstLead: res.data.data.lead_id,
                  }); //oldAnswer为true表示就机器人也没有结果，则展示引导的部分，//控制是否展示引导的内容

                  if (oldAnswer) {
                    //如果就机器人没有回复，则根据引导类型展示引导数据
                    this.dealYindao(res, data.lead_id);
                  } else if (oldAnswer === false) {
                    //如果就机器人有回复，则删掉引导数据库中的这条引导
                    this.backLead(data.lead_id || res.data.data.lead_id);
                  }
                },
                unknown_id: () => {
                  let unknown_id = res.data.data.unknown_id;
                  this.unKnowList.push(unknown_id);
                  this.getOldRobot(keyword);
                },
              };
              replyContent[attr] && replyContent[attr]();

              if (
                data.lead_id &&
                res.data.data.is_related &&
                attr != "error_type"
              ) {
                //修改数据库的引导数据
                this.checkchangeLeadInfo({
                  type: attr,
                  lead_id: data.lead_id,
                });
              }

              if (!res.data.data.unknown_id) {
                this.sendStatistical();
                this.saveChatList(); //保存聊天记录
              } else if (res.data.data.unknown_id && res.data.data.error_type) {
                this.saveChatList(); //保存聊天记录
              }
              // console.log("保存历史记录");
              this.saveHistory(); //缓存历史记录
            } else {
              this.getOldRobot(keyword);
            }
          } catch (err) {
            this.chatList.push({
              target: "r",
              type: "unfound",
              answer: this.defaultReply,
              time: this.getCurrentTime(),
            });
            console.log(err);
          }
        }
      }


    },

    /**
     * 新机器人回复（点击查询）
     * @method query
     */
    async query(keywords, info = null, chatItem = {}) {

      if (info && info.content) {
        this.getNiceRecom(info);
        this.saveHistory();
        this.saveChatList();
        return;
      }

      if (this.guessList.some((item) => item.title === keywords)) {
        this.guess_num = this.guess_num + 1;
      }
        let timeStamp = Date.now();
     
      this.chatList.push({
        target: "u",
        message: keywords,
        time: this.getCurrentTime(),
        sendstatus: true,
        waitStatus: false,
        first: true,
        show_sikao:true, //用户提问后，左边机器人提示正在思考
        sikao_id:timeStamp, //标记这个提问对应的答案共用的关联id 
      });
      let article_id;
      if (info && info.type) {
        article_id = info.id;
        keywords = "";
      } else {
        article_id = "";
      }

      let data = {
        action: "reply",
        keywords: keywords,
        cityname: this.cityname,
        article_id: article_id,
        platform: this.platform,
        cate_id: this.cate_id,
        cate_name: this.cate_name,
        chat_key: this.chatToken,
      };
      if(this.sid){
        data.sid = this.sid
      }
      if (localStorage.getItem("isTest") == 1) {
        data.is_test = localStorage.getItem("isTest");
      }

      if (chatItem.yindaoId) {
        data.lead_id = chatItem.yindaoId;
      }

      let res;
      res = await util.request(data, "post");
      this.cancleSikao(timeStamp)
      // console.log("**********", res);
      if (res.data.state == 1) {
        // console.log("**********", res);
        let attrList = ["art_info", "pro_info", "geli_data"];
        let attr = attrList.find((i) => i in res.data.data);

        const replyContent = {
          art_info: () => {
            this.article_num = this.article_num + 1;

            let art_info = res.data.data.art_info;
            this.chatList.push({
              target: "r",
              type: "article",
              articleInfo: art_info,
              attitude: "无",
              time: this.getCurrentTime(),
            });
          },
          pro_info: () => {
            this.answer_num = this.answer_num + 1;

            let cate_name = "";
            if (res.data.data.in_cate === false) {
              this.cate_id = res.data.data.real_info.real_cate_id;
              this.cate_name = res.data.data.real_info.real_cate_name;
              this.currentCate = this.cate_name;
              cate_name = this.cate_name;
            }

            let pro_info = res.data.data.pro_info;
            // console.log("########", pro_info);

            if (pro_info.supplement) {
              pro_info.supplement = pro_info.supplement.filter(
                (item) => item.name !== "" && item.path !== ""
              );

              if (!pro_info.supplement.length) {
                pro_info.supplement = null;
              }
            }

            if (pro_info.supplement_h5) {
              pro_info.supplement_h5 = pro_info.supplement_h5.filter(
                (item) => item.name !== "" && item.path !== ""
              );

              if (!pro_info.supplement_h5.length) {
                pro_info.supplement_h5 = null;
              }
            }

            if (this.platform == "h5") {
              pro_info.problem_tj_h5
                ? this.chatList.push({
                    target: "r",
                    type: "answer1",
                    pro_info: pro_info,
                    attitude: "无",
                    time: this.getCurrentTime(),
                  })
                : this.chatList.push({
                    target: "r",
                    type: "answer",
                    pro_info: pro_info,
                    attitude: "无",
                    time: this.getCurrentTime(),
                    tuwenStatus: 0,
                    cateType: cate_name,
                  });
            } else {
              pro_info.problem_tj
                ? this.chatList.push({
                    target: "r",
                    type: "answer1",
                    pro_info: pro_info,
                    attitude: "无",
                    time: this.getCurrentTime(),
                  })
                : this.chatList.push({
                    target: "r",
                    type: "answer",
                    pro_info: pro_info,
                    attitude: "无",
                    time: this.getCurrentTime(),
                    tuwenStatus: 0,
                    cateType: cate_name,
                  });
            }
          },

          geli_data: () => {
            this.card_zt_num = this.card_zt_num + 1;
            if (res.data.data.geli_special !== null) {
              //特殊地区
              //   console.log("特殊地区");
              let specialPlaceArr = res.data.data.geli_special;
              let geli_data = res.data.data.geli_data;
              this.chatList.push({
                target: "r",
                type: "special",
                specialPlaceArr: specialPlaceArr,
                geli_data: geli_data,
              });
            } else {
              let geli_data = res.data.data.geli_data;
              //   console.log("非特殊地区");
              let arriveInfo = this.dealStandaerAnswer(geli_data);
              this.pushStandardCArd(geli_data, arriveInfo);
            }
          },
        };
        replyContent[attr] && replyContent[attr]();

        //改变引导数据
        if (data.lead_id) {
          let dataLead = {
            action: "lead_result",
            cityname: this.cityname,
            lead_id: data.lead_id,
            platform: "h5",
            is_success: 1,
          };
          let res1 = await util.request(dataLead);
          // console.log("修改引导的数据", res1);
          this.noresult_num = this.noresult_num - 1;
          // this.saveChatList();
          // this.sendStatistical();
        }

        this.saveChatList();
        this.saveHistory();
        this.sendStatistical();
      }
    },
    /**
     * 旧机器人回复
     * @method getOldRobot
     */
    async getOldRobot(keyword, id = "", lead = {}) {
      if (id) {
        this.chatList.push({
          target: "u",
          message: keyword,
          time: this.getCurrentTime(),
          sendstatus: true,
          waitStatus: false,
          first: true,
        });
      }

      let data = {
        action: "send",
        city: this.cityname,
        cityname: "问答",
        content: keyword,
        time: `time${new Date().getTime()}`,
        group_id: id,
      };
      let res = await util.request(data, "get", "robot.php");

      if (res.data.state) {
        let unFound = "没有找到";
        let content = res.data.data.content.replace(/\r\n\r\n/gim, "<br>");
        if (content.includes(unFound)) {
          if (lead.errorType == "error_type") {
            // console.log("就机器人的error_type");
            if (lead.firstLead) this.noresult_num = this.noresult_num + 1;
            await this.saveChatList();
            await this.sendStatistical();
            return true;
          }
          this.chatList.push({
            target: "r",
            type: "unfound",
            answer: this.defaultReply,
            time: this.getCurrentTime(),
          });
          this.noresult_num = this.noresult_num + 1;
        } else if (content.includes("group_name")) {
          //找到词组
          content = JSON.parse(content);
          this.chatList.push({
            target: "r",
            type: "oldRecom",
            content: content,
            time: this.getCurrentTime(),
          });

          this.keywords_num = this.keywords_num + 1;
        } else {
          //找到对应问题
          this.chatList.push({
            target: "r",
            type: "oldAnswer",
            content: content,
            time: this.getCurrentTime(),
          });

          this.keywords_num = this.keywords_num + 1;
        }
      } else {
        if (lead.errorType == "error_type") {
          // console.log("就机器人的error_type");
          if (lead.firstLead) this.noresult_num = this.noresult_num + 1;
          await this.saveChatList();
          await this.sendStatistical();
          return true;
        }
        this.chatList.push({
          target: "r",
          type: "unfound",
          answer: this.defaultReply,
          time: this.getCurrentTime(),
        });
        this.noresult_num = this.noresult_num + 1;
      }
      this.saveChatList();
      this.saveHistory();
      this.sendStatistical();
      return false;
    },

    /**
     *
     * 石榴
     */
    //点击标准卡片中的电话图标
    handleCallPhone(info) {
      //   console.log("打电话---", info);
      if (info.type == "from") {
        // console.log("出城市", info.code);

        let url =
          info.code == "sz"
            ? `http://m.bendibao.com/news/gelizhengce/tel.php?citycode=${info.code}&chouse=chu&size=0`
            : `http://m.${info.code}.bendibao.com/news/gelizhengce/tel.php?citycode=${info.code}&chouse=chu&size=0`;

        window.open(url);
      } else {
        // console.log("进城市", info.goCityCode);
        let gocode = info.goCityCode;
        let url =
          gocode == "sz"
            ? `http://m.bendibao.com/news/gelizhengce/tel.php?citycode=${gocode}&chouse=jin&size=0`
            : `http://m.${gocode}.bendibao.com/news/gelizhengce/tel.php?citycode=${gocode}&chouse=jin&size=0`;

        window.open(url);
      }
    },

    //点击卡片中高风险对应的政策标题，弹出答案卡片（）
    getDetailToPlace(item, allItem) {
      // console.log("点击卡片，push一个用户信息，在push一个卡片结果", allItem);
      this.chatList.push({
        target: "u",
        message: item.title,
        time: this.getCurrentTime(),
        sendstatus: true,
        waitStatus: false,
        first: true,
      });
      //处理是否需要收起展示
      let flagShowAll = false;
      if (item.contentInfo.length + item.orderInfo.toString().length > 249) {
        flagShowAll = true;
      }
      this.chatList.push({
        target: "r",
        flagShowAll,
        type: "onetosomplace",
        title: item.title,
        content: item.contentInfo,
        yaodian: item.orderInfo,
        getMorePoro: {
          //把隔离数据也携带给这一条机器人回复
          ...allItem.geli_data,
        },
        time: this.getCurrentTime(),
        sendstatus: true,
        waitStatus: false,
        first: true,
      });

      this.card_zt_num = this.card_zt_num + 1;
      this.sendStatistical();
    },

    //点击提示语中的 疫情等级
    gotoYiQingDengJi(item) {
      //   console.log(item);
      this.tongjiEnterZhuanti();
      let citycode = localStorage.getItem("citycode");
      if (citycode == "sz") {
        window.open(`http://m.bendibao.com/news/yqdengji/`);
      } else {
        window.open(`http://m.${citycode}.bendibao.com/news/yqdengji/`);
      }
    },

    // 前往出行政策
    // 点击提示语出行政策 或 点击答案卡片中的查看详情
    //传过去出发地区和目的地
    gotoChuXingZhengCe(info) {
      //   console.log(info);
      this.tongjiEnterZhuanti();
      let url =
        info.fromCityCode == "sz"
          ? `http://m.bendibao.com/news/gelizhengce/all.php`
          : `http://m.${info.fromCityCode}.bendibao.com/news/gelizhengce/all.php`;
      window.open(url);
    },

    //有答案的情况下，点击出行政策，出现标准卡片
    getOtherCard(info) {
      // console.log(info);
      this.chatList.push({
        target: "u",
        message: "出行政策",
        time: this.getCurrentTime(),
        sendstatus: true,
        waitStatus: false,
        first: true,
      });
      if (info.geli_special !== null) {
        //特殊地区
        // console.log("特殊地区");
        let specialPlaceArr = info.geli_special;
        let geli_data = info.geli_data;
        // console.log(specialPlaceArr);
        this.chatList.push({
          target: "r",
          type: "special",
          specialPlaceArr: specialPlaceArr,
          geli_data: geli_data,
        });
      } else {
        //非特殊地区
        let geli_data = info.geli_data;
        let arriveInfo = this.dealStandaerAnswer(geli_data);
        this.pushStandardCArd(geli_data, arriveInfo);
      }
    },

    //点击特殊地区的时候，根据选择的特殊地区，返回对应的标准卡片
    clickSpecialPlace(info) {
      let geli_data = info.detailInfo;
      let choosePlace = info.place;
      let data = {
        target: "u",
        message: "",
        time: this.getCurrentTime(),
        sendstatus: true,
        waitStatus: false,
        first: true,
      };

      if (choosePlace === "以上都不是") {
        data.message = "以上都不是";
        this.chatList.push(data);
        let arriveInfo = this.dealStandaerAnswer(geli_data);
        this.pushStandardCArd(geli_data, arriveInfo, "");
      } else {
        data.message = choosePlace.area + " " + choosePlace.addr;
        this.chatList.push(data);
        this.pushStandardCArd(geli_data, "", choosePlace);
      }

      this.card_zt_num = this.card_zt_num + 1;
      this.sendStatistical();
    },

    //点击出行政策按钮，直接返回 输入始发地和目的地的提示
    clickGoOutButton() {
      this.chatList.push({
        target: "u",
        message: "出行政策",
        time: this.getCurrentTime(),
        sendstatus: true,
        waitStatus: false,
        first: true,
      });

      this.chatList.push({
        target: "r",
        type: "tipinputplace",
        time: this.getCurrentTime(),
      });
      this.saveHistory(); //缓存历史记录
    },

    clickYQDJ() {
      //点击四个按钮中的疫情等级按钮
      this.chatList.push({
        target: "u",
        message: "疫情等级",
        time: this.getCurrentTime(),
        sendstatus: true,
        waitStatus: false,
        first: true,
      });
      this.chatList.push({
        target: "r",
        type: "standartip1",
        city: this.cityname,
        citycode: localStorage.getItem("citycode"),
        time: this.getCurrentTime(),
      });
      this.saveHistory(); //缓存历史记录
    },

    //放置标准卡片
    pushStandardCArd(geli_data, arriveInfo, specialPlace) {
      // console.log("特殊地区", specialPlace);
      this.chatList.push(
        {
          target: "r",
          type: "standardgoout",
          geli_data: geli_data,
          arriveInfo: arriveInfo ? arriveInfo : "", //非特殊地区
          specialPlace: specialPlace ? specialPlace : "", //对应特殊地区
          time: this.getCurrentTime(),
        },
        {
          target: "r",
          type: "standartip1",
          city: this.cityname,
          citycode: this.citycode,
          time: this.getCurrentTime(),
        },
        {
          target: "r",
          type: "standartip2",
          time: this.getCurrentTime(),
        }
      );
    },

    //统计进入专题的次数
    tongjiEnterZhuanti() {
      return new Promise((resolve, reject) => {
        let data = {
          action: "geli_static",
          cityname: this.cityname,
          platform: "app",
        };
        util.request(data, "POST").then((res) => {
          resolve(res);
        });
      });
    },

    //处理标准出行政策卡片中的进城市，中高风险/常态化/通勤/国内外政策的内容
    dealStandaerAnswer(geli_data) {
      // let geli_data = info.geli_data;
      //处理到达城市的相关信息
      let gov = geli_data.leavecity[0].gov;
      if (!gov) {
        gov = [];
      }
      // console.log("隔离数据", geli_data)
      let dremark = geli_data.leavecity[0].dremark;
      let zremark = geli_data.leavecity[0].zremark;
      let gremark = geli_data.leavecity[0].gremark;
      let cremark = geli_data.leavecity[0].cremark;
      let wremark = geli_data.leavecity[0].wremark;
      let toremark = geli_data.leavecity[0].toremark;
      let ttremark = geli_data.leavecity[0].ttremark;
      let dengji = geli_data.leavecity[0].dengji; //登记报备规定
      // this.pushStandardCArd(geli_data);
      let arriveInfo = [];
      let low = 0;
      let mid = 0;
      let high = 0;

      //按照APP的出行政策显示，中高低会显示的和下面的常态化一致
      // for (let i = 0; i < gov.length; i++) {
      //   let obj = {};
      //   if (i == 0) {
      //     // obj.orderInfo = dremark;
      //     obj.contentInfo = gov[i].content;
      //     obj.title = "低风险地区政策";
      //     low = 1;
      //     arriveInfo.push(obj);
      //   }
      //   if (i == 1) {
      //     // obj.orderInfo = zremark;
      //     obj.contentInfo = gov[i].content;
      //     obj.title = "中风险地区政策";
      //     mid = 1;
      //     arriveInfo.push(obj);
      //   }
      //   if (i == 2) {
      //     // obj.orderInfo = gremark;
      //     obj.contentInfo = gov[i].content;
      //     obj.title = "高风险地区政策";
      //     high = 1;
      //     arriveInfo.push(obj);
      //   }
      // }
      //////////////
      //按照新的接口返回数据，中高低风险会有low-btn、mid-btn、high-btn
      for (let i = 0; i < gov.length; i++) {
        let obj = {};
        if (gov[i].class == "low-btn") {
          //低风险
          obj.orderInfo = dremark;
          obj.contentInfo = gov[i].content;
          obj.title = gov[i].title;
          low = 1;
          arriveInfo.push(obj);
        }
        if (gov[i].class == "mid-btn") {
          //中风险
          obj.orderInfo = zremark;
          obj.contentInfo = gov[i].content;
          obj.title = gov[i].title;
          mid = 1;
          arriveInfo.push(obj);
        }
        if (gov[i].class == "high-btn") {
          //高风险
          obj.orderInfo = gremark;
          obj.contentInfo = gov[i].content;
          obj.title = gov[i].title;
          high = 1;
          arriveInfo.push(obj);
        }

        if (gov[i].class == "other-btn1") {
          obj.orderInfo = cremark;
          obj.contentInfo = gov[i].content;
          obj.title = gov[i].title;
          arriveInfo.push(obj);
        }
        if (gov[i].class == "other-btn2") {
          obj.orderInfo = wremark;
          obj.contentInfo = gov[i].content;
          obj.title = gov[i].title;
          arriveInfo.push(obj);
        }
        if (gov[i].class == "other-btn3") {
          obj.orderInfo = toremark;
          obj.contentInfo = gov[i].content;
          obj.title = gov[i].title;
          arriveInfo.push(obj);
        }
        if (gov[i].class == "other-btn4") {
          obj.orderInfo = ttremark;
          obj.contentInfo = gov[i].content;
          obj.title = gov[i].title;
          arriveInfo.push(obj);
        }
      }

      if (dengji) {
        let obj = {};
        obj.orderInfo = [];
        obj.contentInfo = dengji;
        obj.title = "登记/报备规定";
        arriveInfo.push(obj);
      }

      // if (high == 0 && gremark.length !== 0 && gremark[0] !== "") {
      //   let obj = {};
      //   obj.orderInfo = gremark;
      //   obj.contentInfo = "";
      //   obj.title = "高风险地区政策";
      //   arriveInfo.unshift(obj);
      // }
      // if (mid == 0 && zremark.length !== 0 && zremark[0] !== "") {
      //   let obj = {};
      //   obj.orderInfo = zremark;
      //   obj.contentInfo = "";
      //   obj.title = "中风险地区政策";
      //   arriveInfo.unshift(obj);
      // }
      // if (low == 0 && dremark.length !== 0 && dremark[0] !== "") {
      //   let obj = {};
      //   obj.orderInfo = dremark;
      //   obj.contentInfo = "";
      //   obj.title = "低风险地区政策";
      //   arriveInfo.unshift(obj);
      // }

      // console.log("整理的数据", arriveInfo);
      return arriveInfo;
    },

    //点击展开，隐藏展开按钮的显示
    clickShowAll(item) {
      item.flagShowAll = false;
    },
  },
};
</script>
<style>
  
</style>

<style lang="stylus">
@import './new-robot-mobile.styl';
@import './new-robot-pc.styl';

.image-look-mark {
  width: 100px;
}

.answer ol,
.answer ul{
    list-style:normal;
    list-style-position: inside;
}
.container-Moblie{
    .answer p{
        margin-bottom:12px;
    }
    .answer ol,
    .answer ul{
        margin:12px 0
    }
}
.container-PC{
    .answer p{
        margin-bottom:2px;
    }
    .answer ol,
    .answer ul{
        margin:4px 0
    }
}

</style>
